import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { ResponsiveContainer, Treemap, Tooltip } from "recharts";
import { useNavigate } from "react-router-dom";

import "./HeatMap.css";

const getStockColor = (percent) => {
  if (percent > 5) return "#0B7D0B";
  if (percent > 3) return "#1FA61F";
  if (percent > 2) return "#32C832";
  if (percent > 1) return "#6EDC6E";
  if (percent > 0) return "#A8E6A3";
  if (percent === 0) return "#B0B0B0";
  if (percent > -1) return "#F7B1A5";
  if (percent > -2) return "#EF7F73";
  if (percent > -3) return "#E63F36";
  if (percent > -5) return "#C92323";
  return "#991B1B";
};

const CustomizedContent = (props) => {
  const navigate = useNavigate();
  const { x, y, width, height, percent_change, symbol } = props;

  const color = getStockColor(percent_change);
  const pad = 3;

  return (
    <g onClick={() => navigate(`/stockInfo/${symbol}`)}>
      <rect
        x={x + pad}
        y={y + pad}
        width={Math.max(0, width - pad * 2)}
        height={Math.max(0, height - pad * 2)}
        rx={6}
        ry={6}
        fill={color}
        stroke="#020617"
        strokeWidth={1}
      />

      {/* SYMBOL */}
      <text
        x={x + pad + 8}
        y={y + pad + 16}
        textAnchor="start"
        dominantBaseline="middle"
        style={{
          fill: "#000000", // 🔥 BLACK
          fontSize: "0.8rem",
          fontWeight: 700,
        }}
      >
        {symbol}
      </text>

      {/* % CHANGE */}
      {height > 40 && (
        <text
          x={x + pad + 8}
          y={y + pad + 32}
          textAnchor="start"
          dominantBaseline="middle"
          style={{
            fill: "#000000", // 🔥 BLACK
            fontSize: "11px",
            fontWeight: 500,
          }}
        >
          {percent_change > 0 ? "+" : ""}
          {percent_change?.toFixed(2)}%
        </text>
      )}
    </g>
  );
};

const HeatmapTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { symbol, ltp, percent_change } = payload[0].payload;

  return (
    <div
      style={{
        background: "#020617",
        padding: "8px 12px",
        borderRadius: "8px",
        color: "#fff",
        fontSize: "13px",
      }}
    >
      <div style={{ fontWeight: "bold", marginBottom: "4px" }}>{symbol}</div>
      <div>LTP: ₹{ltp}</div>
      <div
        style={{
          color: percent_change >= 0 ? "#22c55e" : "#ef4444",
        }}
      >
        Change: {percent_change.toFixed(2)}%
      </div>
    </div>
  );
};

// const HeatMap = ({ data }) => {
//   const [niftyData, setNiftyData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [statsData, setStatsData] = useState([]);
//   const treemapData = Array.isArray(data)
//     ? data
//         .filter(
//           (d) =>
//             typeof d.marketCap === "number" &&
//             !isNaN(d.marketCap) &&
//             typeof d.percent_change === "number"
//         )
//         .map((d) => ({
//           name: d.symbol, // REQUIRED by recharts
//           symbol: d.symbol,
//           marketCap: d.marketCap, // dataKey
//           percent_change: d.percent_change,
//           ltp: d.ltp,
//         }))
//     : [];

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "500px",
//         backgroundColor: "#0f172a",
//         borderRadius: "12px",
//       }}
//     >
//       <ResponsiveContainer width="100%" height="100%">
//         {/* <Treemap
//           // data={filteredData}
//           dataKey="marketCap"
//           stroke="#0f172a"
//           content={<CustomizedContent />}
//           isAnimationActive={true}
//           aspectRatio={4 / 3}
//         >
//           <Tooltip
//             cursor={{ stroke: "#fff", strokeWidth: 1 }}
//             formatter={(value, name, entry) => {
//               if (name === "price") return `₹${entry.payload.price}`;
//               if (name === "peRatio") return entry.payload.peRatio?.toFixed(2);
//               if (name === "percent_change")
//                 return `${entry.payload.percent_change.toFixed(2)}%`;
//               if (name === "marketCap")
//                 return entry.payload.marketCap?.toLocaleString();
//               return entry?.payload?.symbol || "";
//             }}
//           />
//         </Treemap> */}
//         <ResponsiveContainer width="100%" height="100%">
//           <Treemap
//             data={treemapData}
//             dataKey="marketCap"
//             stroke="#0f172a"
//             content={<CustomizedContent />}
//           >
//             <Tooltip />
//           </Treemap>
//         </ResponsiveContainer>
//       </ResponsiveContainer>
//     </div>
//   );
// };
// const HeatMap = ({ data }) => {
//   console.log("Data received is", data);
//   const treemapData = Array.isArray(data)
//     ? data
//         .filter((d) => typeof d.pChange === "number")
//         .map((d) => ({
//           // name: d?.meta?.companyName,
//           symbol: d.symbol,
//           value: 1,
//           percent_change: d?.pChange,
//           ltp: d?.lastPrice,
//         }))
//     : [];

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "500px",
//         backgroundColor: "#0f172a",
//         borderRadius: "12px",
//       }}
//     >
//       <ResponsiveContainer width="100%" height="100%">
//         <Treemap
//           data={treemapData}
//           dataKey="value" // 🔥 constant sizing
//           stroke="#0f172a"
//           content={<CustomizedContent />}
//         >
//           {/* <Tooltip
//             formatter={(value, name, entry) => {
//               return [
//                 `${entry.payload.percent_change.toFixed(2)}%`,
//                 entry.payload.symbol,
//               ];
//             }}
//           /> */}
//           <Tooltip content={<HeatmapTooltip />} />
//         </Treemap>
//       </ResponsiveContainer>
//     </div>
//   );
// };
// const HeatMap = ({ data, loading }) => {
//   if (loading) {
//     return (
//       <div
//         style={{
//           width: "100%",
//           height: "500px",
//           backgroundColor: "#0f172a",
//           borderRadius: "12px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#94a3b8",
//           fontSize: "14px",
//           fontWeight: 600,
//         }}
//       >
//         Loading heatmap…
//       </div>
//     );
//   }

//   const treemapData = Array.isArray(data)
//     ? data
//         .filter((d) => typeof d.pChange === "number")
//         .map((d) => ({
//           symbol: d.symbol,
//           value: 1,
//           percent_change: d.pChange,
//           ltp: d.lastPrice,
//         }))
//     : [];

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "500px",
//         backgroundColor: "#0f172a",
//         borderRadius: "12px",
//       }}
//     >
//       <ResponsiveContainer width="100%" height="100%">
//         <Treemap
//           data={treemapData}
//           dataKey="value"
//           stroke="#0f172a"
//           content={<CustomizedContent />}
//         >
//           <Tooltip content={<HeatmapTooltip />} />
//         </Treemap>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// const getHeatmapColor = (p) => {
//   if (p === 0) return "#9ca3af"; // neutral

//   // clamp range (-5% to +5%)
//   const min = -5;
//   const max = 5;

//   const value = Math.max(min, Math.min(max, p));

//   // normalize 0 → 1
//   const ratio = (value - min) / (max - min);

//   // interpolate red → green
//   const red = Math.round(220 - ratio * 180);
//   const green = Math.round(50 + ratio * 180);
//   const blue = 60;

//   return `rgb(${red}, ${green}, ${blue})`;
// };
const getHeatmapColor = (p) => {
  if (p >= 5) return "#0f7a2f";
  if (p >= 3) return "#1fa34a";
  if (p >= 1) return "#7bc08a";
  if (p === 0) return "#9ca3af";
  if (p > -1) return "#f28b8b";
  if (p > -3) return "#e74c4c";
  return "#b91c1c";
};

const HeatMap = ({ data = [], loading }) => {
  // 🔥 Sort data (highest → lowest)
  const navigate = useNavigate();
  const sortedData = useMemo(() => {
    return [...data]
      .filter((d) => typeof d.pChange === "number")
      .sort((a, b) => b.pChange - a.pChange);
  }, [data]);
  console.log("data ", data);
  if (loading) return <p>Loading heatmap...</p>;
  console.log("Sorted data", sortedData);
  return (
    <div className="stock-table-container">
      <div className="hm-grid-container">
        {sortedData.map((stock) => (
          <div
            key={stock.symbol}
            className="hm-tile"
            style={{
              background: getHeatmapColor(stock.pChange),
            }}
            onClick={() =>
              // navigate(`/stockInfo/${stock?.symbol}`)
              navigate(`/stockdetail/${stock?.symbol}/${stock?.security_id}`)
            }
          >
            <div className="hm-symbol">{stock.symbol}</div>

            <div className="hm-price">₹{stock.lastPrice?.toFixed(2)}</div>

            <div className="hm-change">
              {stock.pChange > 0 ? "+" : ""}
              {stock.pChange?.toFixed(2)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeatMap;
